/**
 * Twitterの共有URL生成関数
 * @param content 共有するテキスト内容
 * @param url 共有するURL
 * @returns Twitter共有URL
 */
export function generateShareUrlTwitter(content: string, url: string): string {
    const encodedContent = encodeURIComponent(content);
    const encodedUrl = encodeURIComponent(url);
    return `https://twitter.com/intent/tweet?text=${encodedContent}&url=${encodedUrl}`;
}

/**
 * Facebookの共有URL生成関数
 * @param url 共有するURL
 * @returns Facebook共有URL
 */
export function generateShareUrlFB(url: string): string {
    const encodedUrl = encodeURIComponent(url);
    return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
}


